import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcMenuDots = ({ size, color }) => {
  return (
    <Icon
      className="IcMenuDots material-icons tw-block tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      more_vert
    </Icon>
  )
}

IcMenuDots.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
}

export default IcMenuDots
